
const productionBaseUrl = 'http://vms.100xuekao.com/api/home/index.php/';
const devBaseUrl="http://vms.100xuekao.com/api/home/index.php/"
const config = {
    


    //baseUrl:'http://182.254.215.168/virtualexam/www/api/home/index.php/',
    //project_code:"TWO",//项目编码，后台管理中项目里的项目编码，接口数据以这个编码为准,优先查看url有没有project_code这个参数，没有才找配置文件里的这个配置
    assetUrl:"http://vms.100xuekao.com/asset/",



    baseUrl:process.env.NODE_ENV == 'production'?productionBaseUrl:devBaseUrl,

    //不同的考试配置不同的显示按钮
    btn_item:[
        {id:3,text:"特殊字符",name:"tszf"},
        {id:1,text:"标准定额",name:"bzde"},
        {id:2,text:"计算器",name:"jsq"},
    ]

};
export default config;
